import { render } from "./SectionAction.vue?vue&type=template&id=1e7800bd&scoped=true"
import script from "./SectionAction.vue?vue&type=script&lang=js"
export * from "./SectionAction.vue?vue&type=script&lang=js"

import "./SectionAction.vue?vue&type=style&index=0&id=1e7800bd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e7800bd"]])

export default __exports__